<template>
  <DialogPortal to="#teleports">
    <DialogOverlay />
    <DialogContent
      data-slot="dialog-content"
      v-bind="forwarded"
      :class="cn(dialogContentVariants({ size }), props.class)"
    >
      <slot />
      <DialogCloseX v-if="!hideClose" />
    </DialogContent>
  </DialogPortal>
</template>

<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core";
import {
  DialogContent,
  type DialogContentEmits,
  type DialogContentProps,
  DialogPortal,
  useForwardPropsEmits,
} from "reka-ui";
import type { HTMLAttributes } from "vue";
import DialogCloseX from "./DialogCloseX.vue";
import DialogOverlay from "./DialogOverlay.vue";
import { dialogContentVariants, type DialogContentVariants } from "./variants";
import { cn } from "@/lib/utils";

const props = defineProps<
  DialogContentProps & {
    hideClose?: boolean;
    class?: HTMLAttributes["class"];
    size?: DialogContentVariants["size"];
  }
>();
const emits = defineEmits<DialogContentEmits>();

const delegatedProps = reactiveOmit(props, "class", "hideClose", "size");

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>
